import conversionUtcDate from 'src/utils/conversionUtcDate'
import { getLocalAndroidAll } from '/src/@api/dashboard'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'
import { buildTimeParams } from 'src/utils/dateRangeParams'

const readDeviceSnapshot = () => ({
  userData: JSON.parse(localStorage.getItem('userData') || '{}')?.data || { email: '' },
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}')
})

const mapDetail = item => ({
  ...item,
  time: conversionUtcDate(item.date, 'UTC', 'YYYY-MM-DD HH:mm'),
  defaultAvata: '/images/avatars/10.png'
})

const loadSummary = async ({ page, range }) => {
  const { userData, deviceUser } = readDeviceSnapshot()
  const deviceUdid = deviceUser?.username || ''
  const response = await getLocalAndroidAll({
    username: userData.email,
    params: {
      category: 'SMS_SUMMARY',
      offset: (page - 1) * 200,
      limit: 200,
      deviceUdid,
      // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
      ...buildTimeParams(range)
    }
  })
  const data = response.data.contents?.map(item => ({
    ...item,
    guid: item.chatid,
    time: conversionUtcDate(item.snippetTimestamp, 'UTC', 'YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  let defaultSelectData = []
  let rightTotalCount = 0
  if (page === 1 && data[0]) {
    const detail = await getLocalAndroidAll({
      username: userData.email,
      params: {
        category: 'SMS_DETAIL',
        offset: 0,
        limit: 50,
        deviceUdid,
        rid: data[0].chatid,
        ...buildTimeParams(range)
      }
    })
    defaultSelectData = detail.data.contents?.map(mapDetail) || []
    rightTotalCount = detail.data.totalCount
  }

  return {
    data,
    defaultSelectData,
    leftTotalCount: response.data.totalCount,
    ...(page === 1 ? { rightTotalCount } : {})
  }
}

const loadDetail = async ({ contact, page, range }) => {
  const { userData, deviceUser } = readDeviceSnapshot()
  const response = await getLocalAndroidAll({
    username: userData.email,
    params: {
      category: 'SMS_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      rid: contact.guid,
      deviceUdid: deviceUser?.username || '',
      ...buildTimeParams(range)
    }
  })

  return {
    selected: response.data.contents?.map(item => ({ ...mapDetail(item), defaultAvata: '/images/avatars/11.png' })) || [],
    rightTotalCount: response.data.totalCount
  }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'AndroidLocalTextMessages',
  storeKey: 'androidLocalTextMessages',
  actionPrefix: 'androidLocalTextMessages',
  contactKey: 'chatid',
  storageKey: 'smsItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({ fetchLoading: false })
})

export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const removeSelectedChat = chat.removeSelectedChat
export const setMessageDateRange = chat.setDateRange
export default chat.reducer
